<template>
  <naj-confirmation ref="nafathmodal" :show-modal="showModal" :width="500" :no-header="true" :show-close-btn="closeBtn"
    @cancel="onCancel()">
    <template slot="message-content">
      <!-- <v-col
        v-if="showRejectedMessage"
        class="title-container"
      >
        <naj-error-text
          :text="local.nafath.rejectedFailMessage"
          size="large"
          no-margin
        ></naj-error-text>
      </v-col> -->
      <div v-if="showRejectedMessage || showExpiredMessage" class="alert-box">
        <div class="alert-icon">
          <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.3333 3.76676C15.2667 2.98009 16.7733 2.98009 17.68 3.76676L19.7867 5.56676C20.1867 5.90009 20.9467 6.18009 21.48 6.18009H23.7467C25.16 6.18009 26.32 7.34009 26.32 8.75342V11.0201C26.32 11.5534 26.6 12.3001 26.9333 12.7001L28.7333 14.8068C29.52 15.7401 29.52 17.2468 28.7333 18.1534L26.9333 20.2601C26.6 20.6601 26.32 21.4068 26.32 21.9401V24.2068C26.32 25.6201 25.16 26.7801 23.7467 26.7801H21.48C20.9467 26.7801 20.2 27.0601 19.8 27.3934L17.6933 29.1934C16.76 29.9801 15.2533 29.9801 14.3467 29.1934L12.24 27.3934C11.84 27.0601 11.08 26.7801 10.56 26.7801H8.22667C6.81334 26.7801 5.65334 25.6201 5.65334 24.2068V21.9268C5.65334 21.4068 5.38667 20.6468 5.05334 20.2601L3.25334 18.1401C2.48001 17.2201 2.48001 15.7268 3.25334 14.8068L5.05334 12.6868C5.38667 12.2868 5.65334 11.5401 5.65334 11.0201V8.76676C5.65334 7.35342 6.81334 6.19342 8.22667 6.19342H10.5333C11.0667 6.19342 11.8133 5.91342 12.2133 5.58009L14.3333 3.76676Z"
              fill="#FBE5E8" stroke="#D70015" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 11.3398V17.7798" stroke="#D70015" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M15.9927 21.8335H16.0047" stroke="#D70015" stroke-width="3" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <div v-if="showRejectedMessage" class="alert-text">
          {{ local.nafath.rejectedFailMessage }}
        </div>
        <div v-if="showExpiredMessage" class="alert-text">
          {{ local.nafath.expiredFailMessage }}
        </div>
        <div class="alert-close">
          ✖
        </div>
      </div>
      <div id="nafath-icon">
        <svg width="127" height="96" viewBox="0 0 127 96" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_55_324)">
            <path
              d="M105.145 10.8286H22.7435C18.406 10.8286 14.8894 14.3366 14.8894 18.6635V75.2691C14.8894 77.2871 17.0298 78.5903 18.8286 77.6676L20.8858 76.613C32.8997 70.4527 46.2131 67.2396 59.7212 67.2396H105.145C109.482 67.2396 112.999 63.7316 112.999 59.4047V18.6635C112.999 14.3366 109.482 10.8286 105.145 10.8286Z"
              fill="white" />
          </g>
          <path
            d="M107.675 8.80886C107.023 8.80886 106.495 8.28221 106.495 7.63233V3.20681C106.495 2.55693 107.023 2.03027 107.675 2.03027C108.326 2.03027 108.854 2.55693 108.854 3.20681V7.63233C108.854 8.28221 108.326 8.80886 107.675 8.80886Z"
            fill="#008D55" />
          <path
            d="M116.495 15.255C115.844 15.255 115.316 15.7817 115.316 16.4315C115.316 17.0813 115.844 17.608 116.495 17.608H120.931C121.583 17.608 122.111 17.0813 122.111 16.4315C122.111 15.7817 121.583 15.255 120.931 15.255H116.495Z"
            fill="#008D55" />
          <path
            d="M115.263 4.18012C115.817 4.52171 115.988 5.24639 115.646 5.79942L113.314 9.56425C112.971 10.1168 112.245 10.2881 111.691 9.94648C111.137 9.60489 110.965 8.88021 111.307 8.32718L113.639 4.56235C113.982 4.00976 114.708 3.83853 115.263 4.18012Z"
            fill="#008D55" />
          <path
            d="M119.956 8.86167C119.613 8.30907 118.887 8.13785 118.332 8.47944L114.558 10.8057C114.004 11.1473 113.833 11.872 114.175 12.425C114.518 12.9776 115.244 13.1488 115.798 12.8072L119.573 10.481C120.126 10.1394 120.298 9.4147 119.956 8.86167Z"
            fill="#008D55" />
          <path
            d="M121.273 24.0013C120.931 24.5539 120.204 24.7251 119.65 24.3835L115.876 22.0573C115.322 21.7157 115.15 20.991 115.492 20.438C115.835 19.8854 116.561 19.7141 117.116 20.0557L120.89 22.382C121.444 22.7236 121.615 23.4483 121.273 24.0013Z"
            fill="#008D55" />
          <path
            d="M103.658 8.63288C104.212 8.29129 104.383 7.56661 104.041 7.01358L101.709 3.24875C101.367 2.69616 100.64 2.52493 100.086 2.86652C99.5319 3.20811 99.3602 3.9328 99.7026 4.48582L102.035 8.25065C102.377 8.80325 103.103 8.97447 103.658 8.63288Z"
            fill="#008D55" />
          <path
            d="M50.2948 32.4795H29.5096C27.5059 32.4795 25.8816 34.0998 25.8816 36.0986V51.7473C25.8816 53.746 27.5059 55.3664 29.5096 55.3664H50.2948C52.2985 55.3664 53.9228 53.746 53.9228 51.7473V36.0986C53.9228 34.0998 52.2985 32.4795 50.2948 32.4795Z"
            fill="#435363" />
          <path
            d="M40.921 20.4911C45.1502 20.4911 48.5909 23.6691 48.5909 27.5749V35.5672C48.5909 39.4734 45.1502 42.6511 40.921 42.6511C36.6918 42.6511 33.2511 39.473 33.2511 35.5672V27.5749C33.2511 23.6687 36.6918 20.4911 40.921 20.4911ZM40.921 17.585C34.9719 17.585 30.1042 22.0805 30.1042 27.5753V35.5677C30.1042 41.0625 34.9719 45.558 40.921 45.558C46.8701 45.558 51.7378 41.0625 51.7378 35.5677V27.5753C51.7378 22.0805 46.8701 17.585 40.921 17.585Z"
            fill="#435363" />
          <path
            d="M52.1151 32.4795H31.3299C29.3262 32.4795 27.7019 34.0998 27.7019 36.0986V51.7473C27.7019 53.746 29.3262 55.3664 31.3299 55.3664H52.1151C54.1188 55.3664 55.7431 53.746 55.7431 51.7473V36.0986C55.7431 34.0998 54.1188 32.4795 52.1151 32.4795Z"
            fill="#077C5A" />
          <path
            d="M43.4681 42.288C43.4681 40.8836 42.3268 39.7451 40.919 39.7451C39.5111 39.7451 38.3699 40.8836 38.3699 42.288C38.3699 43.2289 38.8831 44.0483 39.6446 44.488V48.1006H42.1938V44.488C42.9549 44.0483 43.4686 43.2289 43.4686 42.288H43.4681Z"
            fill="white" />
          <path
            d="M60.6447 28.8806H105.106C105.416 28.8806 105.668 28.603 105.668 28.2614C105.668 27.9199 105.416 27.6436 105.106 27.6436H60.6447C60.3339 27.6436 60.0808 27.9207 60.0808 28.2614C60.0808 28.6022 60.3339 28.8806 60.6447 28.8806Z"
            fill="#E9E9E9" />
          <path
            d="M60.6447 32.6111H97.205C97.5149 32.6111 97.7672 32.3339 97.7672 31.9932C97.7672 31.6525 97.5149 31.374 97.205 31.374H60.6447C60.3339 31.374 60.0808 31.6516 60.0808 31.9932C60.0808 32.3348 60.3339 32.6111 60.6447 32.6111Z"
            fill="#E9E9E9" />
          <path
            d="M60.6447 36.3455H92.7058C93.0157 36.3455 93.268 36.0683 93.268 35.7276C93.268 35.3869 93.0157 35.1084 92.7058 35.1084H60.6447C60.3339 35.1084 60.0808 35.386 60.0808 35.7276C60.0808 36.0692 60.3339 36.3455 60.6447 36.3455Z"
            fill="#E9E9E9" />
          <path
            d="M105.106 44.835H60.6447C60.3339 44.835 60.0808 45.1121 60.0808 45.4528C60.0808 45.7936 60.3339 46.072 60.6447 46.072H105.106C105.416 46.072 105.668 45.7944 105.668 45.4528C105.668 45.1113 105.416 44.835 105.106 44.835Z"
            fill="#E9E9E9" />
          <path
            d="M67.1082 39.9066L65.5518 40.3292L66.5322 41.4117L65.5395 42.0303L64.5836 40.8963L63.64 42.0303L62.6474 41.4117L63.6523 40.3292L62.1082 39.9066L62.5003 38.9272L64.0077 39.4117L63.9709 38.0303H65.2332L65.1841 39.4117L66.6915 38.9272L67.1082 39.9066Z"
            fill="#435363" />
          <path
            d="M74.1082 39.9066L72.5518 40.3292L73.5322 41.4117L72.5395 42.0303L71.5836 40.8963L70.64 42.0303L69.6474 41.4117L70.6523 40.3292L69.1082 39.9066L69.5003 38.9272L71.0077 39.4117L70.9709 38.0303H72.2332L72.1841 39.4117L73.6915 38.9272L74.1082 39.9066Z"
            fill="#435363" />
          <path
            d="M81.1082 39.9066L79.5518 40.3292L80.5322 41.4117L79.5395 42.0303L78.5836 40.8963L77.64 42.0303L76.6474 41.4117L77.6523 40.3292L76.1082 39.9066L76.5003 38.9272L78.0077 39.4117L77.9709 38.0303H79.2332L79.1841 39.4117L80.6915 38.9272L81.1082 39.9066Z"
            fill="#435363" />
          <path
            d="M88.1082 39.9066L86.5518 40.3292L87.5322 41.4117L86.5395 42.0303L85.5836 40.8963L84.64 42.0303L83.6474 41.4117L84.6523 40.3292L83.1082 39.9066L83.5003 38.9272L85.0077 39.4117L84.9709 38.0303H86.2332L86.1841 39.4117L87.6915 38.9272L88.1082 39.9066Z"
            fill="#435363" />
          <path
            d="M60.6447 49.8064H97.205C97.5149 49.8064 97.7672 49.5292 97.7672 49.1885C97.7672 48.8478 97.5149 48.5693 97.205 48.5693H60.6447C60.3339 48.5693 60.0808 48.8469 60.0808 49.1885C60.0808 49.5301 60.3339 49.8064 60.6447 49.8064Z"
            fill="#E9E9E9" />
          <path
            d="M60.6447 53.5369H92.7058C93.0157 53.5369 93.268 53.2597 93.268 52.919C93.268 52.5783 93.0157 52.2998 92.7058 52.2998H60.6447C60.3339 52.2998 60.0808 52.5774 60.0808 52.919C60.0808 53.2606 60.3339 53.5369 60.6447 53.5369Z"
            fill="#E9E9E9" />
          <defs>
            <filter id="filter0_d_55_324" x="0.889404" y="0.828613" width="126.109" height="95.141"
              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha" />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="7" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_55_324" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_55_324" result="shape" />
            </filter>
          </defs>
        </svg>
      </div>
      <div class="title-container">
        <h1 id="title">
          {{ local.nafath.title }}
        </h1>
      </div>
      <div class="title-container">
        <h2 id="description">
          {{ local.nafath.description }}
        </h2>
      </div>
      <div v-if="nafathOtp.random" class="mainotp">
        <div class="otp">
          {{ nafathOtp.random }}
        </div>
      </div>
      <div class="underline" />
      <div class="validate-otp">
        <button :disabled="disableNewRandom" class="btn new-number-btn" @click="generateNewNafathOtp">
          {{ local.nafath.newNumber }}
        </button>
        <button outlined class="btn cancel-btn" @click="onCancel()">
          {{ local.nafath.cancel }}
        </button>
      </div>
    </template>
  </naj-confirmation>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { nafathStatus } from '@/helpers/enum';
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
export default {
  name: 'NajNafathOtpInput',
  components: {},
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    closeBtn: {
      type: Boolean,
      default: false,
    },
    identityNumber: {
      type: String,
      default: '',
      required: true,
    },
    serviceType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      nafathOtpRequest: {
        socialId: null,
      },
      nafathCheckStatusRequest: {
        transId: null,
        random: null,
        socialId: null,
      },
      nafathOtp: {
        transId: null,
        random: null,
      },
      disableNewRandom: true,
      showRejectedMessage: false,
      showExpiredMessage: false,
      pollingInterval: null,
    };
  },
  mounted() {
  },
  created() {
    this.loadNafathOtp();
  },
  methods: {
    ...mapGlobalActions(['getNafathOtp', 'checkNafathOtpStatus']),
    generateNewNafathOtp() {
      this.disableNewRandom = true;
      this.showRejectedMessage = false;
      this.showExpiredMessage = false;
      this.loadNafathOtp();
    },
    loadNafathOtp() {

      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }

      this.getNafathOtp({
        socialId: this.identityNumber,
        service: this.serviceType,
      })
        .then((response) => {

          if (response.data) {
            this.nafathOtp = response.data;
            this.nafathCheckStatusRequest = {
              socialId: this.identityNumber,
              transId: this.nafathOtp.transId,
              random: this.nafathOtp.random,
            };
            this.checkNafathOtp();
          }
          else {
            this.showRejectedMessage = true;
          }

        });

    },
    checkNafathOtp() {
      this.pollingInterval = setInterval(() => {
        this.checkNafathStatus();
      }, 5000);
    },
    checkNafathStatus() {
      if (!this.nafathOtp?.random) return;
      this.checkNafathOtpStatus(this.nafathCheckStatusRequest)
        .then((result) => {
          if (result.data) {
            const status = result.data.status;
            if (status === nafathStatus.expired || status === nafathStatus.rejected) {
              clearInterval(this.pollingInterval);
              this.disableNewRandom = false;
              if (status == nafathStatus.rejected)
                this.showRejectedMessage = true;
              else
                this.showExpiredMessage = true;
            }
            if (status === nafathStatus.completed) {
              clearInterval(this.pollingInterval);
              this.$emit('authenticationSuccess');
            }
          }
        })
        .catch((err) => {
          clearInterval(this.pollingInterval);
        });
    },
    onCancel() {
      this.$emit('onCancelModal');
      clearInterval(this.pollingInterval);
    },
  },
};
</script>

<style lang="scss" scoped>
.title-container {
  text-align: center;
  padding-bottom: 30px;
}

.underline {
  width: 100%;
  height: 1px;
  background-color: #dbdbdb;
  margin-top: 30px;
}

.validate-otp {
  cursor: pointer;
  color: var(--app-primary-color);
  // text-align: center;
  font-size: 15px;
  padding-top: 20px;
  display: flex;
  gap: 10px;
  justify-content: center;
}

#title {
  font-size: xx-large !important;
}

#description {
  font-size: large !important;
}

.mainotp {
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  font-weight: bold;
  width: 80px;
  height: 80px;
  background-color: #11998e;
  color: white;
  border-radius: 12px;
}

#loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 120px;
  height: 120px;
  margin: -76px 0 0 -76px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #11998e;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

#nafath-icon {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.alert-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fef1f2;
  color: #374151;
  border: 1px solid #fca5a5;
  border-radius: 10px;
  padding: 10px 15px;
  font-family: sans-serif;
  position: relative;
  direction: rtl;
  gap: 10px;
}

.alert-icon {
  color: #dc2626;
  font-size: 20px;
  flex-shrink: 0;
}

.alert-text {
  flex-grow: 1;
  font-size: 14px;
  text-align: center;
}

.alert-close {
  cursor: pointer;
  font-size: 18px;
  color: #374151;
  flex-shrink: 0;
}

.btn {
  padding: 10px 25px;
  border-radius: 10px;
  font-size: 16px;
  font-family: sans-serif;
  cursor: pointer;
  min-width: 170px;
  border: 2px solid;
  transition: background-color 0.3s, color 0.3s;
}

.cancel-btn {
  background-color: white;
  color: #374151;
  border-color: #d1d5db;
  margin-right: 10px;
}

.new-number-btn {
  background-color: white;
  color: #047857;
  border-color: #047857;
  font-weight: bold;
}

.new-number-btn:disabled {
  background-color: #f3f4f6;
  color: #9ca3af;
  border-color: #e5e7eb;
  cursor: not-allowed;
  opacity: 1;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
